export default __webpack_public_path__ + "static/media/guage.e0a4719d.png";